// ponytail: OBFUSCATION, NOT ENCRYPTION. These values are still fully public — the
// browser must decode them to sign S3 requests, so anyone with DevTools has them in
// seconds. The only thing this defeats is automated crawlers that regex bundles for
// the literal `AKIA[0-9A-Z]{16}` pattern, which is the likeliest source of the
// unauthorized uploads. It buys time, nothing more.
//
// Real fix: backend-issued presigned URLs, then delete this file and the three aws*
// config files that import it. See docs/SECURITY_AUDIT_2026-08-06.md §9 Phase 2.

// Accepts the credentials either base64-encoded or plaintext, so one build works
// across environments mid-rollout: dev passes AWS_ACCESS_KEY_ID_B64, while qa and
// prod still pass the plaintext secret until their own secrets are added.
//
// The access key ID decides for both values — they always come from the same
// environment, and its format is unambiguous. The secret key can't self-identify:
// it's 40 chars of the base64 alphabet, so it is itself valid base64 and decoding
// a plaintext one silently yields garbage rather than throwing.
const rawKeyId = process.env.REACT_APP_ACCESS_KEY_ID || ''
const isPlaintext = /^(AKIA|ASIA)[0-9A-Z]{16}$/.test(rawKeyId)

const decode = (v?: string) => (!v || isPlaintext ? v || '' : atob(v))

export const accessKeyId = decode(rawKeyId)
export const secretAccessKey = decode(process.env.REACT_APP_SECRET_ACCESS_KEY)
